export default __webpack_public_path__ + "static/media/RENAULT.dc6504ec.png";